import script from "./ExportPDFModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ExportPDFModal.vue?vue&type=script&setup=true&lang=js"

import "./ExportPDFModal.vue?vue&type=style&index=0&id=2bd78880&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bd78880"]])

export default __exports__